import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './datatable.component';
import { DatatablePaginatorComponent } from './datatable-paginator/datatable-paginator.component';
import { DatatableAdvancedSearcherComponent } from './datatable-advanced-searcher/datatable-advanced-searcher.component';
import { DatatableColumnFilterComponent } from './datatable-column-filter/datatable-column-filter.component';
import { DatatableGlobalSearcherComponent } from './datatable-global-searcher/datatable-global-searcher.component';
import { WmCheckboxModule } from '../checkbox/index';
import { WmTooltipModule } from '../tooltip/index';
import { WmDirectivesModule, WmPipesModule } from '../../shared/index';
import { WmButtonModule } from '../button/index';
import { WmSelectModule } from '../select/index';
import { WmInputModule } from '../input/index';
import { WmSpinnerModule } from '../spinner/index';
import { WmSnackbarModule } from '../snackbar/index';
import { WmMultiselectModule } from '../multiselect/index';
import { WmTransitionModule } from '../transition/index';
import { DatatableService } from './datatable.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [
		DatatableComponent,
		DatatablePaginatorComponent,
		DatatableAdvancedSearcherComponent,
		DatatableColumnFilterComponent,
		DatatableGlobalSearcherComponent
	],
	imports: [
		CommonModule,
		WmCheckboxModule,
		WmTooltipModule,
		WmDirectivesModule,
		WmButtonModule,
		WmSelectModule,
		WmInputModule,
		WmSpinnerModule,
		WmSnackbarModule,
		WmMultiselectModule,
		WmTransitionModule,
		WmPipesModule,
		FormsModule,
		ReactiveFormsModule
	],
	providers: [DatatableService],
	exports: [DatatableComponent, DatatablePaginatorComponent]
})
export class WmDatatableModule {}
